  
  export const getTemplates = async (templateName) => {
    try {
      switch (templateName) {
        case 'test': {
          const module = await import(`./templates/lines/test.js`);
          return module.default || [];
        }
        case 'euro_entry_door': {
            const module = await import(`./templates/lines/${templateName}.js`);
            return module.default || [];
          }
        case 'pleated_screen_template': {
            const module = await import(`./templates/lines/${templateName}.js`);
            return module.default || [];
        }
        case 'patiodoor_template': {
          const module = await import(`./templates/lines/${templateName}.js`);
          return module.default || [];
        }
        // Add more templates here if needed
        default:
          const module = await import(`./templates/lines/${templateName}.js`);
          return module.default || [];

          console.warn('Unknown template:', templateName);
          return [];
      }
    } catch (error) {
      console.error('Error loading template:', error);
      return [];
    }
  };
  